<template>
  <div>

    <div class="container" v-if="this.selectedSinleStore != undefined">
        <div class="row"><div class="col-24">Afspraak opmaken in salon <strong>{{this.selectedSinleStore.UserName}}</strong> <br> {{getSalonAdres (this.selectedSinleStore.Location)}}</div></div>
    </div>

    <div class="container" v-if="this.storeCustomer != undefined">
        <div class="row"><div class="col-24">Afspraak opmaken voor <strong>{{this.storeCustomer.FirstName}}  {{this.storeCustomer.LastName}}</strong></div></div>
    </div>

  <div class="container">
        <div class="row">
            
            <div class="col-lg-12 col-md-12">
                <div class="row">&nbsp;</div>

                <div class="row hidesmall">&nbsp;&nbsp;<h5>Mijn behandelingen</h5></div>
                <div class="row hidesmall titleMenuBasket" v-bind:style="{ 'background-color': getColorApp}">&nbsp;&nbsp;</div>
                <div class="row hidesmall ">&nbsp;</div>

              <div class="col-lg-23 col-sm-24">
                <template v-for="product in cart">
                  <cart-item :product="product" :hidedetails="true" v-if="flgShowDet"></cart-item>
                </template>
              </div>

              <div class="col-lg-23 col-sm-24" v-if="getTotalsAdvance () > 0">
                <hr>
               <div class="row"  v-if="getTotalsAdvance () > 0" style="background-color:#999999;height:30px;line-height: 30px;border-radius:5px;padding-left:5px">
                  <div class="col-18"><strong style="color:#ffffff">Totaal voorschot gevraagd van </strong></div>
                  <div class="col-6" style="color:#ffffff;text-align:right">&euro;{{getTotalsAdvancePrice ()}}&nbsp;&nbsp;</div>
              </div>
              </div>

              <div class="product-btn"  style="color:#111111">
                  <div class="row">&nbsp;</div>
                  <a @click="navigateBack();"><i class="ion-arrow-left-c"  v-if="flgShowDet"  style="color:#111111"></i>Terug</a>
              </div>

            </div>
             <div class="col-lg-12 col-md-12 col-sm-24">
                <div class="row">&nbsp;</div>
                <div class="row">&nbsp;&nbsp;<h5>Kies een datum</h5></div>
                <div class="row titleMenuBasket" v-bind:style="{ 'background-color': getColorApp}">&nbsp;&nbsp;</div>
                <div class="row">&nbsp;</div>
                <cart-datappoint v-if="selectedSinleStore === undefined"></cart-datappoint>
                <singlesalon-cart-datappoint v-if="selectedSinleStore !== undefined"></singlesalon-cart-datappoint>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import CartItem  from '../components/cart/CartItem';
  import CartCheckout from '../components/cart/CartCheckout.vue'
  import CartDateAppoint from '../components/cart/CartDate.vue'
  import SingleSalonCartDateAppoint from '../components/cart/SingleSalonCartDate.vue'

  export default {
    metaInfo () {
      return {
         title: this.title,
         meta : [
              { name: 'description', content: this.metacontent }
            ]
      }
    },
    name: 'product-list',
    props: ['products'],
    data () {
      return {
        cart: this.$store.state.cart,
        storeCustomer : undefined,
        flgShowDet : true,
        title: 'Kies datum',
        metacontent : 'Kies een vrije plaats uit ',
        selectedSinleStore : undefined
      }
    },
    components: {
        cartItem : CartItem,
        'cart-datappoint': CartDateAppoint,
        'singlesalon-cart-datappoint': SingleSalonCartDateAppoint,
    },
    mounted () {
      this.storeCustomer = Vue.$storeCustomer;
      this.title = 'Kies datum - ' + Vue.$storeSettings.StoreName
      this.metacontent = "Kies een vrije plaats bij " + Vue.$storeSettings.StoreName
      this.selectedSinleStore = Vue.$selectedStore;
    },
    computed: {
      getColorApp () {
           return Vue.$storeSettings.ColorApp;
       }
    },
    methods: {
      getSalonAdres (locationname) {
         var arr = locationname.split (",");
         if (arr.length > 1) return arr[1];
         return locationname;
      },
      navigate (item) {
        this.$router.push(item);
      },
      navigateBack () {
        this.navigate ('/cart');
      },
      showDetails () {
         this.flgShowDet = !this.flgShowDet;
      },
      getTotalsAdvance () {
        var tot = 0
        for (var c=0; c < this.cart.length; c++) {
           tot += this.cart[c].PriceAdvance
        }
        return tot;
      },
      getTotalsAdvancePrice () {
        var t = this.getTotalsAdvance ()
        return t.toFixed (2)
      }
    }
  }
</script>
<style  scoped>
  .products {
    background: #F7F8FB;
    padding: 30px 0;
  }
  @media (max-width: 800px) {
      .hidesmall {
        display: none;
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/CartDate.vue